/* Mühle custom integrations carried forward from Kalles 5.2.0 to 5.4.2. */
(() => {
  'use strict';

  function setFacebookClickCookie() {
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if (!fbclid) return;
    const timestamp = Math.floor(Date.now() / 1000);
    const fbc = `fb.1.${timestamp}.${fbclid}`;
    const expires = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `_fbc=${fbc}; path=/; expires=${expires}; SameSite=Lax`;
  }

  function updateFlitsWishlistCount() {
    const counters = document.querySelectorAll('.flits-header-wishlist-a .flits-wishlist-count');
    if (!counters.length) return;

    let count = 0;
    try {
      const customerId = window.flitsThemeAppExtensionObjects?.customer?.customer_id;
      if (customerId && customerId !== '-1') {
        const stored = JSON.parse(localStorage.getItem('flits') || '{}');
        const products = stored?.flits_wishlist_products;
        if (typeof products === 'string' && products.trim()) {
          count = products.split(',').filter(Boolean).length;
        } else if (Array.isArray(products)) {
          count = products.length;
        }
      }
    } catch (error) {
      console.warn('Flits wishlist count could not be read.', error);
    }
    counters.forEach((counter) => { counter.textContent = String(count); });
  }

  function initializeStickyAddToCart() {
    const stickyATC = document.querySelector('[data-sticky-mode="hdt_show_scrolls_outside_the_scope_of_the_form"]');
    if (!stickyATC) return;

    let productForm = document.getElementById(stickyATC.getAttribute('form'));
    if (!productForm) productForm = document.querySelector('.hdt-product-form, form[action*="/cart/add"]');
    if (!productForm) return;

    let ticking = false;
    const checkVisibility = () => {
      const rect = productForm.getBoundingClientRect();
      stickyATC.classList.toggle('show', rect.bottom <= 50);
      ticking = false;
    };
    const onScroll = () => {
      if (ticking) return;
      window.requestAnimationFrame(checkVisibility);
      ticking = true;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    checkVisibility();
  }

  function initializeJudgeMeLinks() {
    document.addEventListener('click', (event) => {
      const previewBadge = event.target.closest('.jdgm-preview-badge');
      if (previewBadge) {
        const reviewsTab = document.querySelector('.ecom-accordion__title[data-target-id="#ecom-wm37vv5s0j"]');
        if (reviewsTab && !reviewsTab.classList.contains('is-open')) reviewsTab.click();
        document.getElementById('ecom-wm37vv5s0j')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      const writeReview = event.target.closest('.jdgm-write-rev-link');
      if (writeReview) {
        const form = document.querySelector('.jdgm-form-wrapper');
        if (!form) return;
        event.preventDefault();
        form.style.display = form.style.display === 'none' ? 'block' : 'none';
      }
    });
  }

  function initializeFlitsAjaxRefresh() {
    document.addEventListener('click', (event) => {
      const loadMore = event.target.closest('wrapp-hdt-lm-main-url a, wrapp-hdt-lm-url a');
      const filterButton = event.target.closest('hdt-richlist button');
      if (!loadMore && !filterButton) return;
      window.setTimeout(() => {
        document.dispatchEvent(new CustomEvent('Flits:AjaxCollection:CollectionUpdated', { bubbles: true }));
        updateFlitsWishlistCount();
      }, 500);
    });
  }

  setFacebookClickCookie();
  initializeJudgeMeLinks();
  initializeFlitsAjaxRefresh();
  document.addEventListener('DOMContentLoaded', () => {
    initializeStickyAddToCart();
    updateFlitsWishlistCount();
    window.setTimeout(updateFlitsWishlistCount, 2000);
    window.setTimeout(updateFlitsWishlistCount, 10000);
  });
  document.addEventListener('Flits:AjaxCollection:CollectionUpdated', updateFlitsWishlistCount);
})();
